export default __webpack_public_path__ + "static/media/079.46a266f1.jpeg";